import React, {useEffect, useState} from "react";
import { Image } from "@arctheme-components/elements/Image/Image";
import { mobileBreakpoint } from "../../../../../entrypoints/theme";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

export const CartItems = ({
  settings,
  items,
  show_vendor = false,
  show_total_price = true,
}) => {
  const isMobile = useMobileBreakpoint(mobileBreakpoint);
  // @ts-ignore
  const AjaxCartQuantity = "ajax-cart-quantity" as keyof JSX.IntrinsicElements;
  const showItemDivider = false;
  const showOptionNames = true;
  const siteUsesSubscriptions = false;
  const showVariantOptions = true;

  // Filter items into one-time purchases and subscriptions
  const oneTimePurchaseItems = items?.filter(
    (item) => !item.selling_plan_allocation,
  );
  const subscriptionItems = items?.filter(
    (item) => item.selling_plan_allocation,
  );
  // @ts-ignore
  // const currencySymbol = window.Alpine?.store('currency').getCurrencySymbol();
  const [currencyCode, setCurrencyCode] = useState('');
  const [currencySymbol, setCurrencySymbol] = useState('');
  useEffect(() => {
    window.addEventListener('currency_initialised' , (event) => {
      setCurrencyCode(event.detail.currency.name);
      setCurrencySymbol(event.detail.currency.symbol);
    });
  }, []);

  const renderLineItem = (line_item, index) => {
    const line_item_price = line_item.price / 100;
    const line_item_quantity = line_item.quantity;
    const line_item_with_quantity_price = line_item_price * line_item_quantity;
    const indexLineItem = index + 1;

    const size = line_item.options_with_values.find(
      (option) => option.name.toLowerCase() === "size",
    );

    const color = line_item.options_with_values.find(
        (option) => option.name.toLowerCase() === "colour" || option.name.toLowerCase() === "color"
    );
    return (
      <React.Fragment key={index}>
        <li
          data-id={indexLineItem}
          id={`${line_item.id}`}
          data-line={indexLineItem}
          key={line_item.id}
          className="minicart-item"
        >
          <div className="flex">
            <a
              href={"/products/" + line_item.handle}
              className="w-[76px] h-auto lg:w-[87px] shrink-0"
            >
              <Image
                imageUrl={line_item.image}
                alt={line_item.product_title}
                isLazy={false}
                classes={"minicart-item__image"}
              />
            </a>

            <div className={`item-details flex-auto`}>
              <div className="item-details__wrapper b2">
                <div className="h-full">
                  <div className="item-details__title-price flex justify-between gap-3">
                    <div className={`${isMobile ? 'h4' : 'h4'} item-details__title-product`}>
                      {line_item.product_title}
                    </div>

                    <div className={`flex items-start`}>
                      <a
                        className={`item__remove font-[20px] no-underline`}
                        style={{ textDecoration: "none" }}
                      >
                        <div
                          data-ajax-cart-request-button={`/cart/change?id=${line_item.key}&quantity=0`}
                        >
                          <i
                            className={`icon icon-close no-underline text-[8px]`}
                          ></i>
                        </div>
                      </a>
                    </div>
                  </div>

                  <div className="item-details__form">
                    <AjaxCartQuantity>
                      <div className="item-details__quantity">
                        <button
                          data-ajax-cart-quantity-minus
                          className="h-auto w-auto border-none"
                        >
                          <span className="icon-minus text-[8px]"></span>
                        </button>
                        <input
                          data-ajax-cart-quantity-input={`${indexLineItem}`}
                          value={line_item_quantity}
                          type="text"
                          className="quantity-control-input h5"
                          data-ajax-cart-static-element
                          readOnly={true}
                        />
                        <button
                          data-ajax-cart-quantity-plus
                          className="h-auto w-auto border-none"
                        >
                          <span className="icon-plus text-[8px]"></span>
                        </button>
                      </div>
                    </AjaxCartQuantity>
                    <div
                      className="flex errors b2"
                      style={{ padding: 0, margin: 0 }}
                      data-ajax-cart-errors={`${line_item.key}`}
                    ></div>
                  </div>
                </div>


                <div className="hidden lg:flex lg:justify-between h-full items-end">
                  <div className={`item-options h6`}>
                    <>
                      {size && (
                        <p className={`option`} data-option-name={size?.name}>
                          {showOptionNames && (
                            <span className={"brs"}>{size?.name}: </span>
                          )}
                          <span className={"brs"}>{size?.value}</span>
                        </p>
                      )}

                      {color && (
                        <p className={`option`} data-option-name={color?.name}>
                          {showOptionNames && (
                            <span className={"brs"}>{color?.name}: </span>
                          )}
                          <span className={"brs"}>{color?.value}</span>
                        </p>
                      )}
                    </>
                  </div>

                  {line_item.selling_plan_allocation && (
                    <div className="b3 item-details__title-plan mt-[8px] flex items-center space-x-[8px]">

                      <div className="brs">
                        {line_item.selling_plan_allocation.selling_plan.name}
                      </div>
                    </div>
                  )}

                  <div className={"flex justify-end"}>
                    <div className={"flex flex-cols h4"}>
                      {!show_total_price ? (
                        <>
                          {line_item.product?.compare_at_price > 0 && (
                              <p className={`item-price font-normal`}>
                                {currencyCode}{currencySymbol + (line_item.product?.compare_at_price / 100).toFixed(0)}
                              </p>
                          )}
                          <p className={`item-price font-normal`}>
                            {currencyCode}{currencySymbol + line_item_price.toFixed(0)}
                          </p>
                        </>
                      ) : (
                        <div className={'flex flex-col text-right'}>
                          {line_item?.selling_plan_allocation?.compare_at_price ? (
                              // Condition 1: If selling plan allocation has compare_at_price
                              <p className={`item-price--compare font-normal line-through`}>
                                {currencyCode}
                                {currencySymbol}
                                {((line_item?.selling_plan_allocation?.compare_at_price * line_item.quantity) / 100).toFixed(0)}
                              </p>
                          ) : line_item.product?.compare_at_price && line_item.discounts.length <= 0 ? (
                              // Condition 2: If product has compare_at_price and no discounts
                              <p className={`item-price--compare font-normal line-through`}>
                                {currencyCode}
                                {currencySymbol}
                                {((line_item.product?.compare_at_price * line_item.quantity) / 100).toFixed(0)}
                              </p>
                          ) : line_item_with_quantity_price != (line_item.original_line_price / 100) && line_item.discounts.length > 0 && (
                              // Condition 3: If line item price does not match original price and there are discounts
                              <p className={`item-price--compare font-normal line-through`}>
                                {currencyCode}
                                {currencySymbol}
                                {(line_item.original_line_price / 100).toFixed(0)}
                              </p>
                          )}
                          <p className={`item-price font-normal`}>
                            {currencyCode} {currencySymbol + (line_item_with_quantity_price).toFixed(0)}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {show_vendor && (
                <small className={`item-vendor`}>{line_item.vendor}</small>
              )}

              {line_item.discounts.length > 0 &&
                <div className={'discounts_applied'}>
                  {line_item.discounts.map((discount, id) => {
                    return (
                        <React.Fragment key={id}>
                          <p className={"brs text-[#394E47]"}>
                            {discount.title}</p>
                        </React.Fragment>
                    );
                  })}
                </div>
              }
            </div>
          </div>
          {isMobile && (
            <div className={`item-details__lower h6`}>
              {showVariantOptions && (
                <>
                  {size && (
                    <div className={`item-options h6`}>
                      <p className={`option`} data-option-name={size?.name}>
                        {showOptionNames && (
                          <span className={"brs"}>{size?.name}: </span>
                        )}
                        <span className={"brs"}>{size?.value}</span>
                      </p>
                    </div>
                  )}

                  {color && (
                    <div className="item-options h6">
                      <p className={`option`} data-option-name={color?.name}>
                        {showOptionNames && (
                          <span className={"brs"}>{color?.name}: </span>
                        )}
                        <span className={"brs"}>{color?.value}</span>
                      </p>
                    </div>
                  )}
                </>
              )}
              {!show_total_price ? (
                <>
                  {line_item.product?.compare_at_price > 0 && (
                      <p className={`item-price--compare font-normal`}>
                        {currencyCode}{currencySymbol + (line_item.product?.compare_at_price / 100).toFixed(0)}
                      </p>
                  )}
                  <p className={`item-price font-normal`}>
                    {currencyCode}{currencySymbol + line_item_price.toFixed(0)}
                  </p>
                </>
              ) : (
                <div className={'flex flex-col text-right'}>
                  {line_item?.selling_plan_allocation?.compare_at_price ? (
                      // Condition 1: If selling plan allocation has compare_at_price
                      <p className={`item-price--compare font-normal line-through`}>
                        {currencyCode}
                        {currencySymbol}
                        {((line_item?.selling_plan_allocation?.compare_at_price * line_item.quantity) / 100).toFixed(0)}
                      </p>
                  ) : line_item.product?.compare_at_price && line_item.discounts.length <= 0 ? (
                      // Condition 2: If product has compare_at_price and no discounts
                      <p className={`item-price--compare font-normal line-through`}>
                        {currencyCode}
                        {currencySymbol}
                        {((line_item.product?.compare_at_price * line_item.quantity) / 100).toFixed(0)}
                      </p>
                  ) : line_item_with_quantity_price != (line_item.original_line_price / 100) && line_item.discounts.length > 0 && (
                      // Condition 3: If line item price does not match original price and there are discounts
                      <p className={`item-price--compare font-normal line-through`}>
                        {currencyCode}
                        {currencySymbol}
                        {(line_item.original_line_price / 100).toFixed(0)}
                      </p>
                  )}
                  <p className={`item-price font-normal`}>
                    {currencyCode}{currencySymbol + (line_item_with_quantity_price).toFixed(0)}
                  </p>
                </div>
              )}
            </div>
          )}
        </li>
        {showItemDivider && <hr className="border-none h-[1px] bg-[#ECEEEF]" />}
      </React.Fragment>
    );
  };

  return (
    <div className={"relative"}>
      {items?.length > 0 && (
        <>
          {siteUsesSubscriptions && subscriptionItems.length > 0 && (
            <ul
              id="subscription-items"
              className="items-list px-[16px] flex flex-col flex-grow"
            >
              <h2 className={"b3__regular"}>Subscription products</h2>
              {subscriptionItems.map((item, index) =>
                renderLineItem(item, index),
              )}
            </ul>
          )}

          {siteUsesSubscriptions && oneTimePurchaseItems.length > 0 && (
            <ul
              id="one-time-purchase-items"
              className="items-list flex flex-col flex-grow"
            >
              <h2 className={"b3__regular"}>One time purchase</h2>
              {oneTimePurchaseItems.map((item, index) =>
                renderLineItem(item, index),
              )}
            </ul>
          )}

          {!siteUsesSubscriptions && items.length > 0 && (
            <ul
              id="one-time-purchase-items"
              className="items-list flex flex-col flex-grow"
            >
              {items.map((item, index) => renderLineItem(item, index))}
            </ul>
          )}
        </>
      )}
    </div>
  );
};
